// extracted by mini-css-extract-plugin
module.exports = {"overlayContainer":"overlayContainer___2NRTG","overlayContainerAbsolute":"overlayContainerAbsolute___R3gtj","active":"active___2hrOr"};